<template>
    <a class="submit" :style="buttonStyle" @click="$emit('click')">
        <transition name="fade" mode="out-in">
            <span key="spin" v-if="isLoading"><Spinner/></span>
            <span key="text" v-else-if="text">{{ text }}</span>
            <div key="slot" v-else>
                <slot/>
            </div>
        </transition>
    </a>
</template>

<script>
import Spinner from './Spinner'

export default {
    name: 'SubmitButton',
    props: {
        text: {},
        isLoading: {},
        size: {
            default: '20px'
        }
    },
    components: {
        Spinner
    },
    computed: {
        buttonStyle() {
            return {
                fontSize: this.size,
            }
        }
    }
}
</script>

<style lang="scss" scoped>
a.submit {
    transition: all 0.2s ease;
    transition-property: box-shadow, color, fill, background-color;

    font-weight: bold;
    text-align: center;
    cursor: pointer;
    color: var(--main-color);
    fill: var(--main-color);
    background-color: var(--other-color);

    padding: 10px 20px 10px 20px;
    margin: 20px;
    text-decoration: none;

    display: inline-flex;
    align-items: center;
    justify-content: center;

    border: none;
    border-radius: 8px;
    box-shadow: 0 0 0 2px var(--main-color);

    &:hover {
        color: var(--other-color);
        fill: var(--other-color);
        background-color: var(--theme-color);
        box-shadow: 0 0 8px 0px var(--theme-color);
    }
}
</style>